import { SYSTEM_ART, type SystemArt } from "./systemArt";

/**
 * The design's system-screen art, drawn exactly as `illustrations.js` does:
 * a 160×160 viewBox, 1.6 round line, ink `#1d1d1f` (the art carries its own
 * colours, so it reads the same under every look). Decorative — the words next
 * to it say everything — so it is hidden from assistive tech.
 *
 * The keyframes live in `themes/_system-screens.css`; `prefers-reduced-motion`
 * stops them there, and `still` stops them for a caller that wants a frozen
 * frame (the design's own `il-still` class).
 */
export function SystemIllustration({
  art,
  still = false,
}: {
  art: SystemArt;
  still?: boolean;
}) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 160 160"
      fill="none"
      stroke="#1d1d1f"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={still ? "il-still" : undefined}
      style={{ display: "block", flex: "none", overflow: "visible" }}
      dangerouslySetInnerHTML={{ __html: SYSTEM_ART[art] }}
    />
  );
}
